export default __webpack_public_path__ + "static/media/Explore.5e30899c.svg";